import { t } from 'i18next';
import axios from 'axios';

//config
import { strings_general_App } from "../config/constants";

function login(username, organizer, password) {



    const link = process.env.REACT_APP_BASE_URL + process.env.REACT_APP_BASE_URL_SUB + process.env.REACT_APP_URL_API_LOGIN;
    const options = {
        method: 'POST',
        url: link,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        data: { "username": username, "password": password, "organizer": organizer }
    };

    return axios.request(options).then(function (response) {
        if (typeof response.data !== 'undefined' && response.data !== null) {
            return { "login": response.data, "msgError": "" };
        } else {
            return { "login": null, "msgError": t('msgErrorGeneral') };
        }
    }).catch(function (error) {
        let msgError = error.message;
        if (typeof error.response !== 'undefined' && error.response !== null) {
            if (typeof error.response.data !== 'undefined' && error.response.data !== null) {
                if (typeof error.response.data.message !== 'undefined' && error.response.data.message !== null && error.response.data.message.toString() !== "") {
                    msgError = error.response.data.message.toString();
                } else {
                    if (typeof error.response.data.error !== 'undefined' && error.response.data.error !== null && error.response.data.error.toString() !== "") {
                        msgError = error.response.data.error.toString();
                    }
                }
            }
        }
        return { "login": null, "msgError": msgError };
    });



};

function verifyLogin(token) {
    const link = process.env.REACT_APP_BASE_URL + process.env.REACT_APP_BASE_URL_SUB + process.env.REACT_APP_URL_API_VERIFY_LOGIN;

    const options = {
        method: 'POST',
        url: link,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        data: { "token": token }
    };

    return axios.request(options).then(function (response) {
        if (typeof response.data !== 'undefined' && response.data !== null) {
            return { "verifylogin": response.data, "msgError": "" };
        } else {
            return { "verifylogin": null, "msgError": t('msgErrorGeneral') };
        }
    }).catch(function (error) {
        let msgError = error.message;
        if (typeof error.response !== 'undefined' && error.response !== null) {
            if (typeof error.response.data !== 'undefined' && error.response.data !== null) {
                if (typeof error.response.data.message !== 'undefined' && error.response.data.message !== null && error.response.data.message.toString() !== "") {
                    msgError = error.response.data.message.toString();
                } else {
                    if (typeof error.response.data.error !== 'undefined' && error.response.data.error !== null && error.response.data.error.toString() !== "") {
                        msgError = error.response.data.error.toString();
                    }
                }
            }
        }
        return { "verifylogin": null, "msgError": msgError };
    });



};

function getTrips(token, company, datefrom, endDate) {
    let link = "";
    if (datefrom !== null) {
        //let to_date = datefrom
        let to_date = endDate;
        link = process.env.REACT_APP_BASE_URL + process.env.REACT_APP_BASE_URL_API + process.env.REACT_APP_BASE_URL_SUB + process.env.REACT_APP_URL_API_TRIPS + "?company=" + company.toString() + "&from_date=" + datefrom.toString() + "&to_date=" + to_date.toString() + '&' + "pagination=false";

    }
    else {

        link = process.env.REACT_APP_BASE_URL + process.env.REACT_APP_BASE_URL_API + process.env.REACT_APP_BASE_URL_SUB + process.env.REACT_APP_URL_API_TRIPS + "?company=" + company.toString();

    }

    const options = {
        method: 'GET',
        url: link,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + token,
        }
    };

    return axios.request(options).then(function (response) {
        if (typeof response.data !== 'undefined' && response.data !== null) {
            return { "trips": response.data, "msgError": "" };
        } else {
            return { "trips": null, "msgError": t('msgErrorGeneral') };
        }
    }).catch(function (error) {
        let msgError = error.message;
        if (typeof error.response !== 'undefined' && error.response !== null) {
            if (typeof error.response.data !== 'undefined' && error.response.data !== null) {
                if (typeof error.response.data.message !== 'undefined' && error.response.data.message !== null && error.response.data.message.toString() !== "") {
                    msgError = error.response.data.message.toString();
                } else {
                    if (typeof error.response.data.error !== 'undefined' && error.response.data.error !== null && error.response.data.error.toString() !== "") {
                        msgError = error.response.data.error.toString();
                    }
                }
            }
        }
        return { "trips": null, "msgError": msgError };
    });


};

async function getReportTicketSummary(token, company, from_date, to_date, modeFile, selectedFilter) {


    let link = process.env.REACT_APP_BASE_URL + process.env.REACT_APP_BASE_URL_API + process.env.REACT_APP_BASE_URL_SUB + process.env.REACT_APP_BASE_URL_SUB_REPORT + process.env.REACT_APP_URL_API_REPORT_GET_TICKETS + "?company=" + company.toString() + "&" + "from_date=" + from_date.toString() + "&" + "to_date=" + to_date.toString() + "&filter_date_type=" + selectedFilter;
    if (modeFile !== "") {
        link = `${link}&view=${modeFile}`
    }

    let modeAccept = "application/json";
    if (modeFile === "csv") {
        modeAccept = "text/csv";
    }

    const options = {
        method: 'GET',
        url: link,
        //responseType: 'blob',
        headers: {
            //'Accept': modeAccept,
            'Content-Type': modeAccept,
            'authorization': 'Bearer ' + token,
        }
    };


    return axios.request(options).then(function (response) {

        if (typeof response.data !== 'undefined' && response.data !== null) {

            return { "report": response.data, "msgError": "" };
        } else {
            return { "report": null, "msgError": t('msgErrorGeneral') };

        }
    }).catch(function (error) {

        let msgError = error.message;

        if (typeof error.response !== 'undefined' && error.response !== null) {
            if (typeof error.response.data !== 'undefined' && error.response.data !== null) {
                if (typeof error.response.data.message !== 'undefined' && error.response.data.message !== null && error.response.data.message.toString() !== "") {
                    msgError = error.response.data.message.toString();
                } else {
                    if (typeof error.response.data.error !== 'undefined' && error.response.data.error !== null && error.response.data.error.toString() !== "") {
                        msgError = error.response.data.error.toString();
                    }
                }
            }
        }
        return { "report": null, "msgError": msgError };
    });
}



function refreshLogin(token) {

    const link = process.env.REACT_APP_BASE_URL + process.env.REACT_APP_BASE_URL_SUB + process.env.REACT_APP_URL_API_REFRESH_LOGIN;

    const options = {
        method: 'POST',
        url: link,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        data: { "refreshToken": token }
    };

    return axios.request(options).then(function (response) {
        if (typeof response.data !== 'undefined' && response.data !== null) {
            return { "refreshlogin": response.data, "msgError": "" };
        } else {
            return { "refreshlogin": null, "msgError": t('msgErrorGeneral') };
        }
    }).catch(function (error) {
        let msgError = error.message;
        if (typeof error.response !== 'undefined' && error.response !== null) {
            if (typeof error.response.data !== 'undefined' && error.response.data !== null) {
                if (typeof error.response.data.message !== 'undefined' && error.response.data.message !== null && error.response.data.message.toString() !== "") {
                    msgError = error.response.data.message.toString();
                } else {
                    if (typeof error.response.data.error !== 'undefined' && error.response.data.error !== null && error.response.data.error.toString() !== "") {
                        msgError = error.response.data.error.toString();
                    }
                }
            }
        }
        return { "refreshlogin": null, "msgError": msgError };
    });


};

function getApplicationList(token) {

    let link = process.env.REACT_APP_BASE_URL + process.env.REACT_APP_BASE_URL_API + process.env.REACT_APP_BASE_URL_SUB + process.env.REACT_APP_URL_API_DEVICES + process.env.REACT_APP_URL_API_DEVICES_GET_APPLICATIONS;
    const options = {
        method: 'GET',
        url: link,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + token,
        }
    };

    return axios.request(options).then(function (response) {

        if (typeof response.data !== 'undefined' && response.data !== null) {
            return { "result": response.data, "msgError": "" };
        } else {
            return { "result": null, "msgError": t('msgErrorGeneral') };

        }
    }).catch(function (error) {
        let msgError = error.message;
        if (typeof error.response !== 'undefined' && error.response !== null) {
            if (typeof error.response.data !== 'undefined' && error.response.data !== null) {
                if (typeof error.response.data.message !== 'undefined' && error.response.data.message !== null && error.response.data.message.toString() !== "") {
                    msgError = error.response.data.message.toString();
                } else {
                    if (typeof error.response.data.error !== 'undefined' && error.response.data.error !== null && error.response.data.error.toString() !== "") {
                        msgError = error.response.data.error.toString();
                    }
                }
            }
        }
        return { "result": null, "msgError": msgError };
    });




}
function getDevicesListPagination(token, app, number, limit, pagination) {
    let link = process.env.REACT_APP_BASE_URL + process.env.REACT_APP_BASE_URL_API + process.env.REACT_APP_BASE_URL_SUB + process.env.REACT_APP_URL_API_DEVICES_GET_DEVICES;
    if (app) {
        link = `${link}?application=${app}`

    }
    if (number) {
        if (!app) {
            link = `${link}?page=${number}`

        }
        else {

            link = `${link}&page=${number}`

        }

    }
    if (limit) {
        link = `${link}&limit=${limit}`

    }
    if (pagination) {
        link = `${link}&pagination=${pagination}`

    }
    const options = {
        method: 'GET',
        url: link,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + token,
        }
    };

    return axios.request(options).then(function (response) {

        if (typeof response.data !== 'undefined' && response.data !== null) {
            return { "result": response.data, "msgError": "" };
        } else {
            return { "result": null, "msgError": t('msgErrorGeneral') };

        }
    }).catch(function (error) {
        let msgError = error.message;
        if (typeof error.response !== 'undefined' && error.response !== null) {
            if (typeof error.response.data !== 'undefined' && error.response.data !== null) {
                if (typeof error.response.data.message !== 'undefined' && error.response.data.message !== null && error.response.data.message.toString() !== "") {
                    msgError = error.response.data.message.toString();
                } else {
                    if (typeof error.response.data.error !== 'undefined' && error.response.data.error !== null && error.response.data.error.toString() !== "") {
                        msgError = error.response.data.error.toString();
                    }
                }
            }
        }
        return { "result": null, "msgError": msgError };
    });

}
function getDevicesList(token, app, name) {
    console.log("search value in datamanager: ", name)
    let link = process.env.REACT_APP_BASE_URL + process.env.REACT_APP_BASE_URL_API + process.env.REACT_APP_BASE_URL_SUB + process.env.REACT_APP_URL_API_DEVICES_GET_DEVICES;
    if (app) {
        link = `${link}?application=${app}`
    }
    if (name) {

        link = app ? (`${link}&name=${name}`) : (`${link}?name=${name}`)

    }
    const options = {
        method: 'GET',
        url: link,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + token,
        }
    };

    return axios.request(options).then(function (response) {

        if (typeof response.data !== 'undefined' && response.data !== null) {
            return { "result": response.data, "msgError": "" };
        } else {
            return { "result": null, "msgError": t('msgErrorGeneral') };

        }
    }).catch(function (error) {
        let msgError = error.message;
        if (typeof error.response !== 'undefined' && error.response !== null) {
            if (typeof error.response.data !== 'undefined' && error.response.data !== null) {
                if (typeof error.response.data.message !== 'undefined' && error.response.data.message !== null && error.response.data.message.toString() !== "") {
                    msgError = error.response.data.message.toString();
                } else {
                    if (typeof error.response.data.error !== 'undefined' && error.response.data.error !== null && error.response.data.error.toString() !== "") {
                        msgError = error.response.data.error.toString();
                    }
                }
            }
        }
        return { "result": null, "msgError": msgError };
    });



}
function updateDeviceDetails(token, data) {

    let link = process.env.REACT_APP_BASE_URL + process.env.REACT_APP_BASE_URL_API + process.env.REACT_APP_BASE_URL_SUB + process.env.REACT_APP_URL_API_DEVICES + process.env.REACT_APP_URL_API_DEVICES_UPDATE_DEVICES + data.id;

    console.log("companies to send:", data)
    const options = {
        method: 'PATCH',
        url: link,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + token,
        },
        data: { "name": data.name, "companies": data.companies }
    };

    return axios.request(options).then(function (response) {

        if (typeof response.data !== 'undefined' && response.data !== null) {
            return { "result": response.data, "msgError": "" };
        } else {
            return { "result": null, "msgError": t('msgErrorGeneral') };

        }
    }).catch(function (error) {
        let msgError = error.message;
        if (typeof error.response !== 'undefined' && error.response !== null) {
            if (typeof error.response.data !== 'undefined' && error.response.data !== null) {
                if (typeof error.response.data.message !== 'undefined' && error.response.data.message !== null && error.response.data.message.toString() !== "") {
                    msgError = error.response.data.message.toString();
                } else {
                    if (typeof error.response.data.error !== 'undefined' && error.response.data.error !== null && error.response.data.error.toString() !== "") {
                        msgError = error.response.data.error.toString();
                    }
                }
            }
        }
        return { "result": null, "msgError": msgError };
    });




}

function getReportCorsa(token, modeFile, date_from, date_to, company, departure_port, destination_port, from_time, selectedFilter) {

    let link = process.env.REACT_APP_BASE_URL + process.env.REACT_APP_BASE_URL_API + process.env.REACT_APP_BASE_URL_SUB + process.env.REACT_APP_BASE_URL_SUB_REPORT + process.env.REACT_APP_URL_API_REPORT_RACE + "?";
    if (from_time !== "") {

        link = `${link}from_time=${from_time}`
    }

    if (company !== "") {
        link = `${link}&company=${company}`
    }

    if (modeFile !== "") {
        link = `${link}&view=${modeFile}`
    }

    if (date_from !== "") {
        link = `${link}&from_date=${date_from}`
    }

    if (date_to !== "") {
        link = `${link}&to_date=${date_to}`
    }

    if (departure_port !== "") {
        link = `${link}&departure_port=${departure_port}`
    }

    if (destination_port !== "") {
        link = `${link}&destination_port=${destination_port}`
    }
    if (selectedFilter !== "") {
        link = `${link}&filter_date_type=${selectedFilter}`;
    }

    console.log(link)
    let modeAccept = "application/pdf";
    if (modeFile === "csv") {
        modeAccept = "text/csv";
    }

    const options = {
        method: 'GET',
        url: link,
        responseType: 'blob',
        headers: {
            'Accept': modeAccept,
            'Content-Type': modeAccept,
            'authorization': 'Bearer ' + token,
        }
    };

    return axios.request(options).then(function (response) {

        if (typeof response.data !== 'undefined' && response.data !== null) {
            return { "report": response.data, "msgError": "" };
        } else {
            return { "report": null, "msgError": t('msgErrorGeneral') };

        }
    }).catch(function (error) {
        let msgError = error.message;
        if (typeof error.response !== 'undefined' && error.response !== null) {
            if (typeof error.response.data !== 'undefined' && error.response.data !== null) {
                if (typeof error.response.data.message !== 'undefined' && error.response.data.message !== null && error.response.data.message.toString() !== "") {
                    msgError = error.response.data.message.toString();
                } else {
                    if (typeof error.response.data.error !== 'undefined' && error.response.data.error !== null && error.response.data.error.toString() !== "") {
                        msgError = error.response.data.error.toString();
                    }
                }
            }
        }
        return { "report": null, "msgError": msgError };
    });


};


function getReportDailySummary(token, modeFile, date_from, date_to, company, selectedFilter) {

    let link = process.env.REACT_APP_BASE_URL + process.env.REACT_APP_BASE_URL_API + process.env.REACT_APP_BASE_URL_SUB + process.env.REACT_APP_BASE_URL_SUB_REPORT + process.env.REACT_APP_URL_API_REPORT_DAILY + "?company=" + company.toString() + "&" + "from_date=" + date_from.toString() + "&" + "to_date=" + date_from.toString() + "&filter_date_type=" + selectedFilter;



    if (modeFile !== "") {
        link = `${link}&view=${modeFile}`
    }


    let modeAccept = "application/pdf";
    if (modeFile === "csv") {
        modeAccept = "text/csv";
    }
    console.log(link)

    const options = {
        method: 'GET',
        url: link,
        responseType: 'blob',
        headers: {
            'Accept': modeAccept,
            'Content-Type': modeAccept,
            'authorization': 'Bearer ' + token,
        }
    };


    return axios.request(options).then(function (response) {

        if (typeof response.data !== 'undefined' && response.data !== null) {
            return { "report": response.data, "msgError": "" };
        } else {
            return { "report": null, "msgError": t('msgErrorGeneral') };

        }
    }).catch(function (error) {
        let msgError = error.message;
        if (typeof error.response !== 'undefined' && error.response !== null) {
            if (typeof error.response.data !== 'undefined' && error.response.data !== null) {
                if (typeof error.response.data.message !== 'undefined' && error.response.data.message !== null && error.response.data.message.toString() !== "") {
                    msgError = error.response.data.message.toString();
                } else {
                    if (typeof error.response.data.error !== 'undefined' && error.response.data.error !== null && error.response.data.error.toString() !== "") {
                        msgError = error.response.data.error.toString();
                    }
                }
            }
        }
        return { "report": null, "msgError": msgError };
    });


};

function getReportCustomSummary(token, modeFile, date_from, date_to, company, selectedFilter) {

    let link = process.env.REACT_APP_BASE_URL + process.env.REACT_APP_BASE_URL_API + process.env.REACT_APP_BASE_URL_SUB + process.env.REACT_APP_BASE_URL_SUB_REPORT + process.env.REACT_APP_URL_API_REPORT_CUSTOM + "?company=" + company.toString() + "&" + "from_date=" + date_from.toString() + "&" + "to_date=" + date_to.toString() + "&filter_date_type=" + selectedFilter;
    if (modeFile !== "") {
        link = `${link}&view=${modeFile}`
    }

    let modeAccept = "application/pdf";
    if (modeFile === "csv") {
        modeAccept = "text/csv";
    }
    console.log(link)

    const options = {
        method: 'GET',
        url: link,
        responseType: 'blob',
        headers: {
            'Accept': modeAccept,
            'Content-Type': modeAccept,
            'authorization': 'Bearer ' + token,
        }
    };


    return axios.request(options).then(function (response) {

        if (typeof response.data !== 'undefined' && response.data !== null) {

            return { "report": response.data, "msgError": "" };
        } else {
            return { "report": null, "msgError": t('msgErrorGeneral') };

        }
    }).catch(function (error) {
        let msgError = error.message;
        if (typeof error.response !== 'undefined' && error.response !== null) {
            if (typeof error.response.data !== 'undefined' && error.response.data !== null) {
                if (typeof error.response.data.message !== 'undefined' && error.response.data.message !== null && error.response.data.message.toString() !== "") {
                    msgError = error.response.data.message.toString();
                } else {
                    if (typeof error.response.data.error !== 'undefined' && error.response.data.error !== null && error.response.data.error.toString() !== "") {
                        msgError = error.response.data.error.toString();
                    }
                }
            }
        }
        return { "report": null, "msgError": msgError };
    });

};

function getPorts(company, token) {

    let link = process.env.REACT_APP_BASE_URL + process.env.REACT_APP_BASE_URL_API + process.env.REACT_APP_BASE_URL_SUB + process.env.REACT_APP_URL_API_REPORT_GET_PORTS + "?company=" + company.toString();

    const options = {
        method: 'GET',
        url: link,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + token,
        }
    };

    return axios.request(options).then(function (response) {

        if (typeof response.data !== 'undefined' && response.data !== null) {
            return { "ports": response.data, "msgError": "" };
        } else {
            return { "ports": null, "msgError": t('msgErrorGeneral') };

        }
    }).catch(function (error) {
        let msgError = error.message;
        if (typeof error.response !== 'undefined' && error.response !== null) {
            if (typeof error.response.data !== 'undefined' && error.response.data !== null) {
                if (typeof error.response.data.message !== 'undefined' && error.response.data.message !== null && error.response.data.message.toString() !== "") {
                    msgError = error.response.data.message.toString();
                } else {
                    if (typeof error.response.data.error !== 'undefined' && error.response.data.error !== null && error.response.data.error.toString() !== "") {
                        msgError = error.response.data.error.toString();
                    }
                }
            }
        }
        return { "ports": null, "msgError": msgError };
    });

}
function getReportPortDuesSummary(token, modeFile, date_from, date_to, departure_port, company/*, selectedFilter*/) {


    let link = process.env.REACT_APP_BASE_URL + process.env.REACT_APP_BASE_URL_API + process.env.REACT_APP_BASE_URL_SUB + process.env.REACT_APP_BASE_URL_SUB_REPORT + process.env.REACT_APP_URL_API_REPORT_PORT + "?company=" + company.toString() + "&" + "from_date=" + date_from.toString() + "&" + "to_date=" + date_to.toString() + "&" + "departure_port=" + departure_port /*+ "&filter_date_type=" + selectedFilter*/;
    if (modeFile !== "") {
        link = `${link}&view=${modeFile}`
    }


    let modeAccept = "application/pdf";
    if (modeFile === "csv") {
        modeAccept = "text/csv";
    }
    console.log(link)

    const options = {
        method: 'GET',
        url: link,
        responseType: 'blob',
        headers: {
            'Accept': modeAccept,
            'Content-Type': modeAccept,
            'authorization': 'Bearer ' + token,
        }
    };


    return axios.request(options).then(function (response) {

        if (typeof response.data !== 'undefined' && response.data !== null) {
            return { "report": response.data, "msgError": "" };
        } else {
            return { "report": null, "msgError": t('msgErrorGeneral') };

        }
    }).catch(function (error) {
        let msgError = error.message;
        if (typeof error.response !== 'undefined' && error.response !== null) {
            if (typeof error.response.data !== 'undefined' && error.response.data !== null) {
                if (typeof error.response.data.message !== 'undefined' && error.response.data.message !== null && error.response.data.message.toString() !== "") {
                    msgError = error.response.data.message.toString();
                } else {
                    if (typeof error.response.data.error !== 'undefined' && error.response.data.error !== null && error.response.data.error.toString() !== "") {
                        msgError = error.response.data.error.toString();
                    }
                }
            }
        }
        return { "report": null, "msgError": msgError };
    });

};


function getReportMonthlySummary(token, modeFile, date_from, date_to, company, selectedFilter) {

    let link = process.env.REACT_APP_BASE_URL + process.env.REACT_APP_BASE_URL_API + process.env.REACT_APP_BASE_URL_SUB + process.env.REACT_APP_BASE_URL_SUB_REPORT + process.env.REACT_APP_URL_API_REPORT_MONTHLY + "?company=" + company.toString() + "&" + "from_date=" + date_from.toString() + "&" + "to_date=" + date_to.toString() + "&filter_date_type=" + selectedFilter;

    if (modeFile !== "") {
        link = `${link}&view=${modeFile}`
    }


    let modeAccept = "application/pdf";
    if (modeFile === "csv") {
        modeAccept = "text/csv";
    }
    console.log(link)

    const options = {
        method: 'GET',
        url: link,
        responseType: 'blob',
        headers: {
            //'Accept': modeAccept,
            'Content-Type': modeAccept,
            'authorization': 'Bearer ' + token,
        }
    };



    return axios.request(options).then(function (response) {

        if (typeof response.data !== 'undefined' && response.data !== null) {
            return { "report": response.data, "msgError": "" };
        } else {
            return { "report": null, "msgError": t('msgErrorGeneral') };

        }
    }).catch(function (error) {
        let msgError = error.message;
        if (typeof error.response !== 'undefined' && error.response !== null) {
            if (typeof error.response.data !== 'undefined' && error.response.data !== null) {
                if (typeof error.response.data.error !== 'undefined' && error.response.data.error !== null && error.response.data.error.toString() !== "") {
                    msgError = error.response.data.error.toString();
                } else {
                    if (typeof error.response.data.message !== 'undefined' && error.response.data.message !== null && error.response.data.message.toString() !== "") {
                        msgError = error.response.data.message.toString();
                    }
                }
            }
        }
        if (error.response) {
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
        } else if (error.request) {
            console.log(error.request);
        } else {
            console.log("Error", error.message);
        }
        console.log(error.config);

        return { "report": null, "msgError": msgError };
    });


};

function getTripsRoute(token, company, route, from_date, to_date) {
    let link = process.env.REACT_APP_BASE_URL + process.env.REACT_APP_BASE_URL_API + process.env.REACT_APP_BASE_URL_SUB + process.env.REACT_APP_URL_API_TRIPS + "?company=" + company.toString() + "&route=" + route + '&' + "pagination=false" + "&" + "from_date=" + from_date + "&" + "to_date=" + to_date;

    const options = {
        method: 'GET',
        url: link,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + token,
        }
    };

    return axios.request(options).then(function (response) {
        if (typeof response.data !== 'undefined' && response.data !== null) {
            return { "trips": response.data, "msgError": "" };
        } else {
            return { "trips": null, "msgError": t('msgErrorGeneral') };
        }
    }).catch(function (error) {
        let msgError = error.message;
        if (typeof error.response !== 'undefined' && error.response !== null) {
            if (typeof error.response.data !== 'undefined' && error.response.data !== null) {
                if (typeof error.response.data.message !== 'undefined' && error.response.data.message !== null && error.response.data.message.toString() !== "") {
                    msgError = error.response.data.message.toString();
                } else {
                    if (typeof error.response.data.error !== 'undefined' && error.response.data.error !== null && error.response.data.error.toString() !== "") {
                        msgError = error.response.data.error.toString();
                    }
                }
            }
        }
        return { "trips": null, "msgError": msgError };
    });

};

function getReportItinerario(token, company, from_date, to_date, departure_port, destination_port, modeFile, selectedFilter) {

    let link = process.env.REACT_APP_BASE_URL + process.env.REACT_APP_BASE_URL_API + process.env.REACT_APP_BASE_URL_SUB + process.env.REACT_APP_BASE_URL_SUB_REPORT + process.env.REACT_APP_URL_API_REPORT_GET_TRIPS + "?company=" + company.toString() + "&" + "from_date=" + from_date.toString() + "&" + "to_date=" + to_date.toString() + "&" + "departure_port=" + departure_port + "&" + "destination_port=" + destination_port + "&filter_date_type=" + selectedFilter;
    console.log("getTripsmanagerlink", link)
    if (modeFile !== "") {
        link = `${link}&view=${modeFile}`
    }

    let modeAccept = "application/pdf";
    if (modeFile === "csv") {
        modeAccept = "text/csv";
    }

    const options = {
        method: 'GET',
        url: link,
        responseType: 'blob',
        headers: {
            'Accept': modeAccept,
            'Content-Type': modeAccept,
            'authorization': 'Bearer ' + token,
        }
    };


    return axios.request(options).then(function (response) {

        if (typeof response.data !== 'undefined' && response.data !== null) {

            return { "report": response.data, "msgError": "" };
        } else {
            return { "report": null, "msgError": t('msgErrorGeneral') };

        }
    }).catch(function (error) {
        let msgError = error.message;
        if (typeof error.response !== 'undefined' && error.response !== null) {
            if (typeof error.response.data !== 'undefined' && error.response.data !== null) {
                if (typeof error.response.data.message !== 'undefined' && error.response.data.message !== null && error.response.data.message.toString() !== "") {
                    msgError = error.response.data.message.toString();
                } else {
                    if (typeof error.response.data.error !== 'undefined' && error.response.data.error !== null && error.response.data.error.toString() !== "") {
                        msgError = error.response.data.error.toString();
                    }
                }
            }
        }
        return { "report": null, "msgError": msgError };
    });


}

function getSettings(token) {

    let link = process.env.REACT_APP_BASE_URL + process.env.REACT_APP_BASE_URL_API + process.env.REACT_APP_BASE_URL_SUB + process.env.REACT_APP_URL_API_SETTINGS;

    const options = {
        method: 'GET',
        url: link,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + token,
        }
    };

    return axios.request(options).then(function (response) {

        if (typeof response.data !== 'undefined' && response.data !== null) {
            return { "result": response.data, "msgError": "" };
        } else {
            return { "result": null, "msgError": t('msgErrorGeneral') };

        }
    }).catch(function (error) {
        let msgError = error.message;
        if (typeof error.response !== 'undefined' && error.response !== null) {
            if (typeof error.response.data !== 'undefined' && error.response.data !== null) {
                if (typeof error.response.data.message !== 'undefined' && error.response.data.message !== null && error.response.data.message.toString() !== "") {
                    msgError = error.response.data.message.toString();
                } else {
                    if (typeof error.response.data.error !== 'undefined' && error.response.data.error !== null && error.response.data.error.toString() !== "") {
                        msgError = error.response.data.error.toString();
                    }
                }
            }
        }
        return { "result": null, "msgError": msgError };
    });



}


async function updateSettings(token, data) {

    let link = process.env.REACT_APP_BASE_URL + process.env.REACT_APP_BASE_URL_API + process.env.REACT_APP_BASE_URL_SUB + process.env.REACT_APP_URL_API_SETTINGS;
    return axios
        .put(
            link,
            data,
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`
                }
            }
        )
        .then(response => {
            if (typeof response.data !== 'undefined' && response.data !== null) {
                return { "data": response.data, "msgError": "" };
            } else {
                return { "data": null, "msgError": t('msgErrorGeneral') };

            }
        })
        .catch(error => {
            return { "data": null, "msgError": error };
        });
}

async function createUser(token, data) {
    const link =
        process.env.REACT_APP_BASE_URL +
        process.env.REACT_APP_BASE_URL_API +
        process.env.REACT_APP_BASE_URL_SUB +
        process.env.REACT_APP_URL_API_USERS;

    try {
        const response = await axios.post(
            link,
            data,
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        if (response?.data) {
            return {
                data: response.data,
                msgError: "",
            };
        }

        return {
            data: null,
            msgError: t("msgErrorGeneral"),
        };
    } catch (error) {
        return {
            data: null,
            msgError: normalizeApiError(error),
        };
    }
}

async function updateUser(token, userId, data) {
    const link =
        process.env.REACT_APP_BASE_URL +
        process.env.REACT_APP_BASE_URL_API +
        process.env.REACT_APP_BASE_URL_SUB +
        process.env.REACT_APP_URL_API_USERS +
        `/${userId}`; // include the user ID in the URL

    try {
        const response = await axios.put(link, data, {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        });

        if (response?.data) {
            return {
                data: response.data,
                msgError: "",
            };
        }

        return {
            data: null,
            msgError: t("msgErrorGeneral"),
        };
    } catch (error) {
        return {
            data: null,
            msgError: normalizeApiError(error),
        };
    }
}

async function getUsers(token, params = {}) {
    const link =
        process.env.REACT_APP_BASE_URL +
        process.env.REACT_APP_BASE_URL_API +
        process.env.REACT_APP_BASE_URL_SUB +
        process.env.REACT_APP_URL_API_USERS;

    try {
        const response = await axios.get(
            link,
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                params: {
                    page: params.page || 1,
                    limit: params.limit || 10,
                    search: params.search || "",
                },
            }
        );

        if (response?.data) {
            return {
                data: response.data,
                msgError: "",
            };
        }

        return {
            data: null,
            msgError: t("msgErrorGeneral"),
        };
    } catch (error) {
        return {
            data: null,
            msgError: normalizeApiError(error),
        };
    }
}

async function getUser(token, userId) {
    const link =
        process.env.REACT_APP_BASE_URL +
        process.env.REACT_APP_BASE_URL_API +
        process.env.REACT_APP_BASE_URL_SUB +
        process.env.REACT_APP_URL_API_USERS +
        `/${userId}`;

    try {
        const response = await axios.get(link, {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        });

        if (response?.data) {
            return {
                data: response.data,
                msgError: "",
            };
        }

        return {
            data: null,
            msgError: t("msgErrorGeneral"),
        };
    } catch (error) {
        return {
            data: null,
            msgError: normalizeApiError(error),
        };
    }
}

async function getRoles(token) {

    const link =
        process.env.REACT_APP_BASE_URL +
        process.env.REACT_APP_BASE_URL_API +
        process.env.REACT_APP_BASE_URL_SUB +
        process.env.REACT_APP_URL_API_ROLES;

    try {
        const response = await axios.get(
            link,
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                }
            }
        );
        if (response?.data) {
            return {
                data: response.data,
                msgError: "",
            };
        }

        return {
            data: null,
            msgError: t("msgErrorGeneral"),
        };
    } catch (error) {
        return {
            data: null,
            msgError: normalizeApiError(error),
        };
    }
}

async function getReportTypes(token) {

    const link =
        process.env.REACT_APP_BASE_URL +
        process.env.REACT_APP_BASE_URL_API +
        process.env.REACT_APP_BASE_URL_SUB +
        process.env.REACT_APP_BASE_URL_SUB_REPORT +
        process.env.REACT_APP_URL_API_REPORT_TYPES

    try {
        const response = await axios.get(
            link,
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                }
            }
        );
        if (response?.data) {
            return {
                data: response.data,
                msgError: "",
            };
        }

        return {
            data: null,
            msgError: t("msgErrorGeneral"),
        };
    } catch (error) {
        return {
            data: null,
            msgError: normalizeApiError(error),
        };
    }
}

async function getRoutes(token, date, departurePort, time = null, company = null) {

    const link =
        process.env.REACT_APP_BASE_URL +
        process.env.REACT_APP_BASE_URL_API +
        process.env.REACT_APP_BASE_URL_SUB +
        process.env.REACT_APP_URL_API_ROUTES;

    try {

        const params = {
            date,
            departurePort
        };

        if (time) params.time = time;
        if (company) params.company = company;

        const response = await axios.get(link, {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            params
        });

        if (response?.data) {
            return {
                data: response.data,
                msgError: "",
            };
        }

        return {
            data: null,
            msgError: t("msgErrorGeneral"),
        };

    } catch (error) {
        return {
            data: null,
            msgError: normalizeApiError(error),
        };
    }
}

async function getManageBoardingUserList(token, company) {

    const link =
        process.env.REACT_APP_BASE_URL +
        process.env.REACT_APP_BASE_URL_API +
        process.env.REACT_APP_BASE_URL_SUB +
        process.env.REACT_APP_URL_API_ROUTES + process.env.REACT_APP_URL_API_MANAGE_BOARDING_USER_LIST;

    try {

        const params = {
            company
        };

        const response = await axios.get(link, {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            params
        });

        if (response?.data) {
            return {
                data: response.data,
                msgError: "",
            };
        }

        return {
            data: null,
            msgError: t("msgErrorGeneral"),
        };

    } catch (error) {
        return {
            data: null,
            msgError: normalizeApiError(error),
        };
    }
}

async function manageBoarding(token, payload) {
    const link =
        process.env.REACT_APP_BASE_URL +
        process.env.REACT_APP_BASE_URL_API +
        process.env.REACT_APP_BASE_URL_SUB +
        process.env.REACT_APP_URL_API_ROUTES +
        process.env.REACT_APP_URL_API_MANAGE_BOARDING;

    try {
        await axios.post(link, payload, {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        });


        return { msgError: "" };
    } catch (error) {
        return { msgError: normalizeApiError(error) };
    }
}


function normalizeApiError(error) {

    if (error?.response?.data?.errors) {
        const errorText = Object.values(error?.response?.data?.errors).join(". ");

        return errorText;
    }
    if (error?.response?.data?.message) {
        return error.response.data.message;
    }

    if (error?.response?.status === 401) {
        return t("unauthorized");
    }

    if (error?.response?.status === 403) {
        return t("forbidden");
    }

    if (error?.response?.status >= 500) {
        return t("server_error");
    }

    if (error?.message) {
        return error.message;
    }

    return t("msgErrorGeneral");
}





export default { updateSettings, getSettings, getApplicationList, getDevicesListPagination, getDevicesList, updateDeviceDetails, login, verifyLogin, refreshLogin, getTrips, getReportCorsa, getReportDailySummary, getReportCustomSummary, getReportPortDuesSummary, getReportMonthlySummary, getPorts, getTripsRoute, getReportItinerario, getReportTicketSummary, createUser, updateUser, getUsers, getUser, getRoles, getReportTypes, getRoutes, getManageBoardingUserList, manageBoarding }
